import { useScrollStore } from "@faire/web/common/ScrollStore";
import { useRef } from "react";

export const useBackgroundScrollBlocking = (
  allowBackgroundScroll?: boolean
) => {
  const { pushNoScroll, popNoScroll } = useScrollStore([
    "pushNoScroll",
    "popNoScroll",
  ]);

  const shouldPopScrollStore = useRef(false);

  const handleAfterOpen = () => {
    if (!allowBackgroundScroll) {
      pushNoScroll();
      shouldPopScrollStore.current = true;
    }
  };

  const handleAfterClose = () => {
    maybePopScrollStore();
  };

  const maybePopScrollStore = () => {
    if (shouldPopScrollStore.current) {
      popNoScroll();
      shouldPopScrollStore.current = false;
    }
  };
  return {
    handleAfterOpen,
    handleAfterClose,
  };
};
